import { MutableRefObject, useRef } from "react";
import { useGetAllUsersQuery, UserDataFragment } from "@bonliva-crm/graphql";
import { useLocale } from "@hooks";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { UserSelectFilter } from "./_common/user-select-filter";

export type ResponsiblePersonFilterProps = FilterWithFavouriteProps;

export const ResponsiblePersonFilter = (props: ResponsiblePersonFilterProps) => {
  const { locale } = useLocale();
  const title = props.label ?? locale["Responsible BA"];

  const users = useGetAllUsersQuery({ fetchPolicy: "network-only" });

  const { current: fakeUsers }: MutableRefObject<UserDataFragment[]> = useRef([
    {
      __typename: "User",
      _id: "[any]",
      Name: locale.ResponsiblePersonAny,
      Deleted: false,
      Enabled: true,
      Teams: []
    },
    {
      __typename: "User",
      _id: "empty",
      Name: locale.ResponsiblePersonEmpty,
      Deleted: false,
      Enabled: true,
      Teams: []
    }
  ]);

  const options = users.data?.users ? [...fakeUsers, ...users.data.users] : [];

  return (
    <UserSelectFilter
      label={title}
      options={options}
      prependUsers={fakeUsers}
      {...props}
    />
  );
};
